import { render, staticRenderFns } from "./SubHeaderWithHome.vue?vue&type=template&id=3498dd34&scoped=true&"
import script from "./SubHeaderWithHome.vue?vue&type=script&lang=js&"
export * from "./SubHeaderWithHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3498dd34",
  null
  
)

export default component.exports